import styled from 'styled-components';
import {
  borderRadius,
  boxShadow,
  verticalGutter,
  breakpoints
} from '../../styles';

export default styled.div`
  /* position right by default */
  background: #fff none no-repeat bottom right;
  background-image: ${({ mobileBackgroundImage }) =>
    mobileBackgroundImage ? `url(${mobileBackgroundImage})` : 'none'};
  background-size: contain;
  border-radius: ${borderRadius.large};
  box-shadow: ${boxShadow.medium};
  padding: ${({ fill }) => (fill ? '0' : `${verticalGutter * 0.75}rem`)};
  height: 100%;
  overflow: hidden;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    background-image: ${({ backgroundImage }) =>
      backgroundImage ? `url(${backgroundImage})` : 'none'};
    padding: ${({ fill }) => (fill ? '0' : `${verticalGutter}rem`)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/ModuleContainer/ModuleContainer.style.js